var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tItems),function(item){return _c('div',{key:item.field},[_c('mdb-input',{attrs:{"type":"text","value":_vm.$t(item.field),"disabled":"","label":item.name}},[_c('translate-modal',{attrs:{"slot":"append","category":item.category,"sub-category":item.subCategory,"name":item.name},slot:"append"})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }